import { A } from '../actions/pages';
import update from 'immutability-helper';

const initialState = {
  productsPageState: {
    search: '',
  },
};

const pages = (state = initialState, action) => {
  switch (action.type) {
    case A.SAVE_PRODUCTS_PAGE_STATE:
      return update(state, {
        productsPageState: {
          $set: action.data,
        },
      });

    default:
      return state;
  }
};

export default pages;
